// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Panel":"bcq_a bhj_ea bhj_kb bhj_js bhj_sl bhj_wj"};